<template>
    <v-row justify="center">
        <modalconfirm ref="modalConfirmEdit" @action="simpanEdit" />
        <v-dialog v-model="dialog" persistent max-width="600">
            <v-card>
                <v-card-title class="text-h6" v-if="propAdd == 'tambah'">Tambah Konfigurasi Biaya Pengiriman</v-card-title>
                <v-card-title class="text-h6" v-else>Edit Konfigurasi Biaya Pengiriman</v-card-title>
                <v-card-text>
                    <v-row>
                        <v-col cols="12" sm="12" md="12">
                            <v-col cols="12" md="6" class="pb-0">
                                <v-autocomplete outlined dense v-model="provinsi" @focus="() => responseError.province_id = ''"
                                    :error-messages="responseError.province_id" :items="province" label="Provinsi" item-text="province"
                                    item-value="province_id" @change="getCity" :disabled="propAdd == 'edit' || (isCity && propAdd == 'tambah')"
                                    no-data-text="Tidak ada data yang sesuai"></v-autocomplete>
                            </v-col>
                            <v-col cols="12" md="6" class="pb-0" v-if="isCity">
                                <v-autocomplete outlined dense v-model="kota" @focus="() => responseError.city_id = ''"
                                    :error-messages="responseError.city_id" :items="city" label="Kota/Kabupaten" :item-text="item => `${item.type} ${item.city_name}`"
                                    item-value="city_id" :disabled="propAdd == 'edit'" no-data-text="Tidak ada data yang sesuai"></v-autocomplete>
                            </v-col>
                            <v-col cols="12" md="6" class="pb-0">
                                <v-currency-field outlined dense @focus="() => responseError.price = ''" :error-messages="responseError.price"
                                    v-model="price" label="Biaya Pengiriman"></v-currency-field>
                            </v-col>
                        </v-col>
                    </v-row>
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="grey darken-1" outlined @click="batal" class="text-capitalize">Batal</v-btn>
                    <v-btn color="primary" depressed @click="simpan" class="text-capitalize">Simpan</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <v-snackbar v-model="snackbar" :timeout="timeout" right top :color="snackbarClass">
            {{ text }}
            <template v-slot:action="{ attrs }">
                <v-btn color="white" text v-bind="attrs" @click="snackbar = false">
                    <v-icon>mdi-close</v-icon>
                </v-btn>
            </template>
        </v-snackbar>
    </v-row>
</template>

<script>
import { mapActions, mapState } from 'vuex'
export default {
    data() {
        return {
            page: 1,
            limit: "10",
            params: [],
            area_selected: '',
            provinsi: '',
            kota: '',
            price: '',
            subdistrict_selected: '',
            snackbarClass: "green accent-4",
            snackbar: false,
            text: "",
            timeout: 2000,
            paramAdd: {
                province_id: '',
                city_id: '',
                price: '',
            },
        }
    },
    props: {
        value: Boolean,
        propAdd: String,
        isCity: Boolean,
        edit: String,
        val: Object
    },
    computed: {
        ...mapState('so', ['responseError', 'response']),
        // ...mapState('supplierList', ['province', 'city']),
        ...mapState('warehouseList', ['province', 'city', 'subdistrict']),

        dialog: {
            get() {
                return this.value
            },
            set(value) {
                this.$emit('input', value)
            }
        }
    },
    methods: {
        ...mapActions('warehouseList', ['getProvinceOption', 'getCityOption']),
        ...mapActions('so', ['getDeliveryPrice', 'addDeliveryPrice', 'updateDeliveryPrice']),

        getCity() {
            if (!this.isCity) {
                this.kota = '';
            }
            this.getCityOption(this.provinsi)
        },
        batal() {
            this.dialog = false
            this.responseError.province_id = ''
            this.responseError.province_name = ''
            this.responseError.city_id = ''
            this.responseError.city_name = ''
            this.responseError.price = ''
        },
        simpan() {
            this.paramAdd.province_id = this.provinsi
            this.paramAdd.province_name = this.subdistrict_selected.province
            this.paramAdd.city_id = this.kota
            this.paramAdd.city_name = this.subdistrict_selected.city_name
            this.paramAdd.price = this.price
            if (this.paramAdd) {
                if (this.propAdd == 'tambah') {
                    this.addDeliveryPrice(this.paramAdd).then(() => {
                        if (this.response.code == 200) {
                            if(this.isCity){
                                this.getDeliveryPrice(this.queryString({ limit: this.limit, page: this.page, params: [...this.params, { field: 'delivery_setting_province_id', type: 'numeric', comparison: '=', value: this.provinsi }, { field: 'delivery_setting_city_id', type: 'numeric', comparison: '<>', value: 0 }], sort: this.sortBy, dir: 'ASC' }))
                            } else {
                                this.getDeliveryPrice({ limit: this.limit, page: 1, params: this.params, sort: this.sortBy, dir: 'ASC' })
                            }
                            this.dialog = false
                            this.reset()
                        }
                    })
                } else {
                    if(!this.isCity) {
                        this.$refs.modalConfirmEdit.setMessage('Melakukan perubahan pada biaya pengiriman di tingkat provinsi akan mempengaruhi semua biaya pengiriman di tingkat kota/kabupaten yang berada di dalam provinsi tersebut. Apakah Anda yakin ingin melakukan perubahan?')
                        this.$refs.modalConfirmEdit.showConfirm()
                    } else {
                        this.simpanEdit()
                    }
                    // this.updateDeliveryPrice(this.paramAdd).then(() => {
                    //     if (this.response.code == 200) {
                    //         if(this.isCity){
                    //             this.getDeliveryPrice(this.queryString({ limit: this.limit, page: this.page, params: [...this.params, { field: 'delivery_setting_province_id', type: 'numeric', comparison: '=', value: this.provinsi }, { field: 'delivery_setting_city_id', type: 'numeric', comparison: '<>', value: 0 }], sort: this.sortBy, dir: 'ASC' }))
                    //         } else {
                    //             this.getDeliveryPrice({ limit: this.limit, page: 1, params: this.params, sort: this.sortBy, dir: 'ASC' })
                    //         }
                    //         this.dialog = false
                    //         this.reset()
                    //     }
                    // })
                }
            }
        },
        simpanEdit() {
            this.updateDeliveryPrice(this.paramAdd).then(() => {
                if (this.response.code == 200) {
                    this.$refs.modalConfirmEdit.hideConfirm()
                    if(this.isCity){
                        this.getDeliveryPrice(this.queryString({ limit: this.limit, page: this.page, params: [...this.params, { field: 'delivery_setting_province_id', type: 'numeric', comparison: '=', value: this.provinsi }, { field: 'delivery_setting_city_id', type: 'numeric', comparison: '<>', value: 0 }], sort: this.sortBy, dir: 'ASC' }))
                    } else {
                        this.getDeliveryPrice({ limit: this.limit, page: 1, params: this.params, sort: this.sortBy, dir: 'ASC' })
                    }
                    this.dialog = false
                    this.reset()
                }
            })
        },
        reset() {
            this.paramAdd.province_id = ''
            this.paramAdd.province_name = ''
            this.paramAdd.city_id = ''
            this.paramAdd.city_name = ''
            this.paramAdd.price = ''
            this.provinsi = ''
            this.kota = ''
            this.price = ''
            this.responseError.city_id = ''
            this.responseError.city_name = ''
            this.responseError.province_id = ''
            this.responseError.province_name = ''
            this.responseError.price = ''
        }
    },
    watch: {
        val() {
            this.paramAdd.id = this.val.delivery_setting_id
            this.provinsi = this.val.delivery_setting_province_id
            this.price = this.val.delivery_setting_price
            if (this.provinsi) {
                this.getCityOption(this.provinsi)
            }
            this.kota = this.val.delivery_setting_city_id
        }
    },
    created() {
        this.getProvinceOption()
    }
}
</script>
